export default __webpack_public_path__ + "static/media/080.86fa090e.jpg";